export default __webpack_public_path__ + "static/media/team_chaotic_avatar-01.a5566e73.png";